import { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./index.scss";
import img from "../../../assets/images/texture.png";
import { CertifIcon } from "../../../assets/icons/CertifIcon";
import { FormulIcon } from "../../../assets/icons/FormulIcon";
import { useNavigate } from "react-router-dom";
export default function ParallaxSection() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById("parallax-section");
      if (section) {
        const rect = section.getBoundingClientRect();
        const offset = window.innerHeight - rect.top; // combien la section est visible
        if (offset > 0 && offset < window.innerHeight * 2) {
          setScrollY(offset);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const navigate = useNavigate();
  return (
    <section id="parallax-section" className="parallax-section">
      <Container>
        <Row className="align-items-center text-center">
          <Col lg={2} md={1} className=" d-md-block d-none"></Col>
          <Col>
            <div className="content-block">
              <div className="title">
                {" "}
                ALMA <br className="d-md-block d-none" /> SECRET NE Cache{" "}
                <br className="d-md-block d-none" /> rien.
              </div>
              <div className="icons-liste d-flex justify-content-start align-items-center ">
                <div className="d-flex align-items-center justify-content-center icon-item">
                  <CertifIcon /> Ingrédients certifiés <br />
                  uniquement
                </div>
                <div className="d-flex align-items-center justify-content-center icon-item">
                  <FormulIcon /> Formules 100 % <br /> transparentes
                </div>
              </div>

              <button
                className="btn-apropos mt-5"
                onClick={() => {
                  navigate("/all-products?type=nouveaux");
                  window.scrollTo(0, 0);
                }}>
                A PROPOS
              </button>
              <div className="images d-md-block d-none">
                <img
                  src={img}
                  alt="shape1"
                  className="shape shape1"
                  style={{
                    transform: `translateY(${50 - scrollY * 0.2}px)`,
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
